(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-consultation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-video-consult-section]');
    if (!section || section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';

    const form = section.querySelector('#VideoConsultationForm');
    const toggles = section.querySelectorAll('[data-help-toggle]');

    const pacificDateParts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    const pacificDate = Object.fromEntries(pacificDateParts.map(({ type, value }) => [type, value]));
    const earliestAppointmentDate = `${pacificDate.year}-${pacificDate.month}-${pacificDate.day}`;
    section.querySelectorAll('[data-appointment-date]').forEach((input) => {
      input.min = earliestAppointmentDate;
    });

    const updateDetails = () => {
      toggles.forEach((toggle) => {
        const details = section.querySelector(`[data-help-details="${toggle.dataset.helpToggle}"]`);
        if (details) details.hidden = !toggle.checked;
      });
    };

    toggles.forEach((toggle) => toggle.addEventListener('change', updateDetails));
    updateDetails();

    form?.addEventListener('submit', (event) => {
      let firstInvalid;
      section.querySelectorAll('[data-required-group]').forEach((group) => {
        const valid = Boolean(group.querySelector('input[type="checkbox"]:checked'));
        const message = group.querySelector('.video-consult__group-error');
        if (message) message.hidden = valid;
        group.toggleAttribute('data-invalid', !valid);
        if (!valid && !firstInvalid) firstInvalid = group;
      });

      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalid.querySelector('input')?.focus({ preventScroll: true });
      }
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    section.querySelectorAll('.video-consult__reveal').forEach((item) => observer.observe(item));

    if (section.querySelector('[data-video-consult-success]')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'video_consultation_submit' });
      section.querySelector('[data-video-consult-success]').focus();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
